import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ConfirmDeleteModalComponent } from 'src/app/modules/core/components/delete-modal/confirm-delete-modal-component';
import { ArrayHelper } from 'src/app/models/helpers/array-helper';
import { ModalPlantedTreesComponent } from '../modal-planted-trees/modal-planted-trees/modal-planted-trees.component';
export class PlantedTreesComponent {
    constructor(plantingSiteService, _modalService) {
        this.plantingSiteService = plantingSiteService;
        this._modalService = _modalService;
        this.areaTreeSpecies = [];
        this.totalTreeSpecies = [];
        this.totalCertifiedSpecies = [];
        this.confirmDeleteMsg = "Are you sure you want to delete";
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.calculateMiscAmount();
        });
    }
    saveSpecies(species) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield this.plantingSiteService.saveSpecies(species, this.plantingSiteAreaId);
            species.id = result;
            this.areaTreeSpecies.push(species);
            this.totalTreeSpecies.push(species);
            this.calculateMiscAmount();
        });
    }
    editSpecies(species) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.plantingSiteService.saveSpecies(species, this.plantingSiteAreaId);
            let index = this.areaTreeSpecies.findIndex(x => x.id == species.id);
            this.areaTreeSpecies[index] = species;
            this.areaTreeSpecies = ArrayHelper.sortBy(this.areaTreeSpecies, true, coll => coll.species);
            this.calculateMiscAmount();
        });
    }
    delete(species) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.confirmDeleteModal.showAwait(this.confirmDeleteMsg);
            if (result) {
                yield this.plantingSiteService.deleteSpecies(species.id);
                let index = this.areaTreeSpecies.findIndex(x => x.id == species.id);
                this.areaTreeSpecies.splice(index, 1);
                index = this.totalTreeSpecies.findIndex(x => x.id == species.id);
                this.totalTreeSpecies.splice(index, 1);
                this.calculateMiscAmount();
            }
        });
    }
    calculateMiscAmount() {
        if (this.totalTreeSpecies === undefined)
            return false;
        const sumAllSpecies = this.totalTreeSpecies.reduce((sum, current) => sum + +current.count, 0);
        const sumAllCertificate = this.totalCertifiedSpecies.reduce((sum, current) => sum + +current.count, 0);
        // this.miscAmount = this.totalAmount - sumAllCertificate;
        this.miscAmount = sumAllSpecies - sumAllCertificate;
        sessionStorage.setItem('miscAmount_' + this.plantingSiteAreaId, this.miscAmount.toString());
    }
    openModal(treeSpecies) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.treeSpeciesModal = Object.assign({}, treeSpecies);
            const initialState = {
                speciesDto: this.speciesDto,
                misc: this.miscAmount,
                isEditPlantedTree: true,
                plantingSiteAreaId: this.plantingSiteAreaId,
                treeSpecies: this.treeSpeciesModal,
            };
            this.modalRef = this._modalService.show(ModalPlantedTreesComponent, {
                class: "modal-lg",
                initialState,
                keyboard: false,
            });
            this.modalRef.content.isSaved$.subscribe((value) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (value) {
                    yield this.areaTreeSpecies.splice(this.areaTreeSpecies.findIndex(e => e.id === treeSpecies.id), 1, this.treeSpeciesModal);
                    yield this.totalTreeSpecies.splice(this.totalTreeSpecies.findIndex(e => e.id === treeSpecies.id), 1, this.treeSpeciesModal);
                    this.calculateMiscAmount();
                }
            }));
        });
    }
    totalSpeciesInArea() {
        const sum = this.areaTreeSpecies.reduce((sum, current) => sum + +current.count, 0);
        return sum;
    }
}
